import _ from 'lodash';

const uniqid = require('uniqid');

export default class AppEvents {
  static subscriptions = []; // to store the subscribed events by specific components
  static eventHooks = []; // to store the master copy of event listeners
  static globalHooks = [];
  static EVENT_REGISTER = { // only this events would be hooked for pub-sub
    CREATE_EVENT_STEP_BAR: 'CREATE_EVENT_STEP_BAR',
    CREATE_EVENT_LOGO_CLICK: 'CREATE_EVENT_LOGO_CLICK',
    EVENT_MANEGEMENT_MENU_WAP: 'EVENT_MANEGEMENT_MENU_WAP',
    GET_EVENT_TOKEN: 'GET_EVENT_TOKEN',
    WAP_BACK_BUTTON_CLICKED: 'WAP_BACK_BUTTON_CLICKED',
    WAP_BACK_BUTTON_CLICKED_GR: 'WAP_BACK_BUTTON_CLICKED_GR',
    OUTLOOK_CONTACTS: 'OUTLOOK_CONTACTS',
    YAHOO_CONTACTS: 'YAHOO_CONTACTS',
    HANDLE_CLICK_OUTSIDE: 'HANDLE_CLICK_OUTSIDE',
    GIFT_LIST_BACK_BUTTON_CLICKED: 'GIFT_LIST_BACK_BUTTON_CLICKED',
  };
  static EVENT_TYPE = {
    CLICK: 'click',
  };
  static EVENT_HOOK = {
    WINDOW: 'window',
    DOCUMENT: 'document',
  };

  static hookEvent(eventListener, eventFunction) {
    let exist = false;
    if (this.EVENT_REGISTER[eventListener]) {
      this.eventHooks.forEach((f) => {
        if (f.eventName === eventListener) {
          exist = true;
        }
      });
      if (!exist) {
        this.eventHooks.push({ eventName: eventListener, event: eventFunction });
      }
    }
  }

  static unhookEvent(eventListener) {
    this.eventHooks = _.reject(this.eventHooks, { eventName: eventListener });
  }

  static hookGlobalEvent(globalHook, eventType, eventFunction) {
    const hook = globalHook; // this.EVENT_HOOK[globalHook];
    let exist = false;
    if (hook) {
      this.globalHooks.forEach((item) => {
        if (item === hook) {
          exist = true;
        }
      });
      if (!exist && hook) {
         
        eval(hook).addEventListener(eventType, eventFunction);
         
        this.globalHooks.push({ hook, eventType });
      }
    }
  }

  static unhookGlobalEvent(globalHook, eventType) {
    if (globalHook) {
       
      eval(globalHook).removeEventListener(eventType, () => { });
       
    }
    this.globalHooks = _.reject(this.globalHooks, { hook: globalHook });
  }

  static subscribe(eventListener) {
    const masterEvent = _.find(this.eventHooks, { eventName: eventListener });
    if (masterEvent) {
      const subscribedEvent = { eventName: uniqid(eventListener + '_'), event: masterEvent.event };
      this.subscriptions.push(subscribedEvent);
      return subscribedEvent.eventName;
    }
    return null;
  }

  static unsubscribe(eventListener) {
    this.subscriptions = _.reject(this.subscriptions, { eventName: eventListener });
  }

  static publish(eventName, data) {
    this.subscriptions.forEach((f) => {
      if (f.eventName === eventName) {
        f.event.apply(null, data);
      }
    });
  }
}
